module.exports = __webpack_public_path__ + "img/25_16.1ed62815.png";